import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaRocket, FaShieldAlt, FaUsers, FaStar } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./About.css";
import aboutImg from "../../assets/about.jpeg";

const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      offset: 50,
      easing: "ease-out-expo",
    });
  }, []);

  return (
    <section className="about-wrapper">
      {/* ================= HEADER ================= */}
      <header className="about-header" data-aos="fade-down">
        <div className="about-heading-group">
          <div className="about-label">About The Company</div>
          <h2 className="about-heading">
            Redefining the <br />
            <span className="gradient-text">Digital Future</span>
          </h2>
        </div>
      </header>

      {/* ================= BODY ================= */}
      <div className="about-body">
        <div className="about-inner">
          
          {/* LEFT: TEXT CONTENT */}
          <div className="about-content" data-aos="fade-right">
            <p className="about-lead">
              Founded in <strong>2025</strong> by <strong>Vijay Bharghav</strong>, 
              Vijay Software Solutions Private Limited is at the forefront of the technology revolution. 
              We don't just write code; we architect the digital backbone for modern enterprises.
            </p>

            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <FaRocket />
                </div>
                <div className="feature-text">
                  <h4>Fast Delivery</h4>
                  <p>Rapid deployment without compromising quality.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaShieldAlt />
                </div>
                <div className="feature-text">
                  <h4>Secure Core</h4>
                  <p>Enterprise-grade security built into every layer.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaUsers />
                </div>
                <div className="feature-text">
                  <h4>Expert Team</h4>
                  <p>Veteran developers and strategists at your service.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <FaStar />
                </div>
                <div className="feature-text">
                  <h4>Premium Quality</h4>
                  <p>Bespoke solutions tailored for high impact.</p>
                </div>
              </div>
            </div>

            <button className="modern-btn" onClick={() => navigate("/contact")}>
              Start a Project
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </div>

          {/* RIGHT: VISUALS (Image + Effects) */}
          <div className="about-visuals" data-aos="fade-left">
            {/* Background Glow Effect */}
            <div className="blob-glow"></div>

            {/* Image Frame */}
            <div className="image-frame">
              <img src={aboutImg} alt="Vijay Software Solutions Team" />
              
              {/* Floating Glass Badge */}
              <div className="glass-badge">
                <span className="badge-number">100%</span>
                <span className="badge-label">Success</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;